import type { BranchDto } from 'korint-sdk';

export const isQuoteDerogationApproved = (branch: BranchDto | undefined): boolean =>
  Boolean(
    branch?.derogations?.some(
      derogation => derogation.action === 'QUOTE' && derogation.status === 'APPROVED',
    ),
  );

/**
 * Once the wholesaler approved the quote derogation, only the wholesaler may still
 * edit the risk basis (guarantees, franchises, risk questions) — the retail is locked.
 */
export const shouldDisableQuoteFields = (
  branch: BranchDto | undefined,
  firmType?: string,
): boolean => firmType !== 'WHOLESALE' && isQuoteDerogationApproved(branch);
